import dayjs from 'dayjs';

export type DateFormat =
  | 'date'
  | 'datetime'
  | 'time'
  | 'dateyear'
  | 'filter-format'
  | 'datetimeyear';

export const dateFormat = (type: DateFormat) => {
  switch (type) {
    case 'date':
      return 'D MMMM';
    case 'datetime':
      return 'DD MMMM, HH:mm';
    case 'dateyear':
      return 'D MMM YYYY';
    case 'datetimeyear':
      return 'ddd, DD MMM YYYY, HH:mm';
    case 'time':
      return 'HH:mm:ss';
    case 'filter-format':
      return 'YYYY-MM-DD';
    default:
      return 'DD MM YYYY';
  }
};

export const formatTitle = (title: string) => {
  return title.toLowerCase().replace(/\s+/g, '-');
};

export const unformatTitle = (title: string) => {
  return title
    .replace(/-/g, ' ')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const formatDateLabel = (dateString) => {
  const date = dayjs(dateString);
  const currentDate = dayjs();
  const diffHours = currentDate.diff(date, 'hour');
  const diffDays = currentDate.diff(date, 'day');
  const diffMinutes = currentDate.diff(date, 'minute');

  if (diffDays === 0) {
    if (diffMinutes <= 1) {
      return 'posted recently';
    } else if (diffMinutes < 60) {
      return `posted ${diffMinutes} minutes ago`;
    } else if (diffHours === 1) {
      return 'posted 1 hour ago';
    } else {
      return `posted ${diffHours} hours ago`;
    }
  } else if (diffDays === 1) {
    return 'posted yesterday';
  } else if (diffDays < 7) {
    return `posted ${diffDays} days ago`;
  } else {
    // More than a week ago
    return date.format('DD MMM YYYY');
  }
};
